// use this file in your main App.vue
// to include service worker functionality.
import {
    Workbox,
    messageSW
} from "workbox-window";

export default {
    data(){
        return{
          lastUpdateCheck: 0,
          updateInterval: null,
        };
    },
    created() {
        if ("serviceWorker" in navigator) {
            const wb = new Workbox("service-worker.js");

            // Add an event listener to detect when the registered
            // service worker has installed but is waiting to activate.
            wb.addEventListener('waiting', ()=>{
                console.log("SW WAITING!");
                this.$store.commit('serviceWorkerUpdateIsAvailable');
            });

            wb.addEventListener('externalwaiting', ()=>{
                /*
                https://developers.google.com/web/tools/workbox/modules/workbox-window

                If an external service worker is waiting to activate,
                it likely means a user has is attempting to get a new
                version of your site in another tab, but they're blocked
                because this tab is still open.

                If this happens, you may consider showing showing a
                notification to the user asking them to close this tab.
                In extreme cases, you may even consider calling window.reload()
                if doing so won't cause the user to lose any saved state.
                */

                // mp035, we just show the prompt which
                // will


                console.log("EXTERNAL SW WAITING!");
                this.$store.commit('serviceWorkerUpdateIsAvailable');
            });

            wb.addEventListener("activated", event => {
                console.log("SW ACTIVATED!");
                window.location.reload();
            });

            wb.addEventListener("externalactivated", event => {
                console.log("EXTERNAL SW ACTIVATED!");
                window.location.reload();
            });

            wb.addEventListener("externalinstalled", event => {
                console.log("EXTERNAL SW INSTALLED!");
            });

            wb.register().then(reg => {
                this.$store.commit('setWorkBoxRegistration', reg);
                this.updateInterval = window.setInterval(() => {
                        //console.log("Interval SW check V75", new Date());
                        let timeNow = new Date().getTime();
                        let hours6 = 6 * 60 * 60 * 1000;
                        if (timeNow - this.lastUpdateCheck > hours6) {
                            console.log("Checking for service worker update.");
                            reg.update();
                            this.lastUpdateCheck = new Date().getTime();
                        }
                    },
                    1000 * 15);

                reg.onupdatefound = () => {
                    console.log("SW update found.");
                    const installingWorker = reg.installing;
                    installingWorker.onstatechange = () => {
                        // just for indication on the console.
                        console.log(`Installing worker state changed to: ${installingWorker.state}`);
                    };
                };

                console.log("SW Registration Promise Completed");
            });
        }
    },
}
